import { TextField, TextFieldProps } from "react-aria-components";
import { FormLabel } from "../FormLabel";
import { FieldError } from "../FieldError";
import type { ErrorMessageType } from "../FieldError";
import { Input } from "../Input";
import styles from "./FormTextField.module.css";

export interface MyTextFieldProps extends TextFieldProps {
  label: string;
  description?: string;
  errorMessage?: ErrorMessageType;
  placeholder?: string;
}

const FormTextField = ({
  label,
  description,
  placeholder,
  errorMessage,
  isDisabled,
  ...props
}: MyTextFieldProps) => (
  <TextField className={styles.formTextField} {...props}>
    <FormLabel
      label={label}
      description={description}
      isDisabled={isDisabled}
    />
    <Input placeholder={placeholder} disabled={isDisabled} />
    <FieldError errorMessage={errorMessage} />
  </TextField>
);

export default FormTextField;
